/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Credit_Packs_SubtitleInputs */

const en_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra AI actions when you need them. One-time purchase, never expires.`)
};

const de_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra KI-Aktionen, wenn du sie brauchst. Einmalkauf, laufen nie ab.`)
};

const fr_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions IA supplementaires quand vous en avez besoin. Achat unique, n'expire jamais.`)
};

const es_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones de IA adicionales cuando las necesites. Compra unica, nunca caducan.`)
};

const it_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azioni IA extra quando ne hai bisogno. Acquisto unico, non scade mai.`)
};

const nl_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra AI-acties wanneer je ze nodig hebt. Eenmalige aankoop, verloopt nooit.`)
};

const pl_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodatkowe akcje AI, gdy ich potrzebujesz. Jednorazowy zakup, nigdy nie wygasa.`)
};

const fi_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisää AI-toimintoja tarvittaessa. Kertaostos, ei vanhene koskaan.`)
};

const da_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstra AI-handlinger nar du har brug for dem. Engangskob, udlober aldrig.`)
};

const sv_pricing_credit_packs_subtitle = /** @type {(inputs: Pricing_Credit_Packs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra AI-handlingar nar du behover dem. Engangskop, gar aldrig ut.`)
};

/**
* | output |
* | --- |
* | "Extra AI actions when you need them. One-time purchase, never expires." |
*
* @param {Pricing_Credit_Packs_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_credit_packs_subtitle = /** @type {((inputs?: Pricing_Credit_Packs_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Credit_Packs_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_credit_packs_subtitle(inputs)
	if (locale === "fr") return fr_pricing_credit_packs_subtitle(inputs)
	if (locale === "es") return es_pricing_credit_packs_subtitle(inputs)
	if (locale === "it") return it_pricing_credit_packs_subtitle(inputs)
	if (locale === "nl") return nl_pricing_credit_packs_subtitle(inputs)
	if (locale === "pl") return pl_pricing_credit_packs_subtitle(inputs)
	if (locale === "fi") return fi_pricing_credit_packs_subtitle(inputs)
	if (locale === "da") return da_pricing_credit_packs_subtitle(inputs)
	if (locale === "sv") return sv_pricing_credit_packs_subtitle(inputs)
	return en_pricing_credit_packs_subtitle(inputs)
});